import { useEffect } from 'react';
import ProjectUtils from "../../../../../utils/project-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const IndividualsContent = ({ data, boName }) => {

    useEffect(() => {
        if (!data?.length) return;
        const values = [];

        data.forEach(element => {

            values.push([
                element.id,
                element.type,
                element.qty,
                ProjectUtils.formatCpfToView(element.cpf),
                element.name !== "Não informado" ? ReportUtils.formatText(element.name) : element.name
            ]);

        });

        ReportUtils.createExportableTable([`${boName}`, "Tipo de apreensão", "Quantidade", "CPF", "Nome"], values, "Indivíduos envolvidos");

    }, [data, boName]);

    return null;
};

export default IndividualsContent;